var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "socials" },
    _vm._l(_vm.socials, function (social, name) {
      return _c("div", { key: name, staticClass: "column" }, [
        _c(
          "a",
          {
            staticClass: "social",
            attrs: { rel: "nofollow", target: "_blank", href: social.url },
          },
          [_c(social.icon, { tag: "component" })],
          1
        ),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }